import React from "react";
import { Container } from "reactstrap";
import { overviewItems } from "../../data/overviewItems";
import OverviewHeader from "./OverviewHeader";
import OverviewCard from "./OverviewCard";

const scrollToHash = (event, href, attempts = 0) => {
  const id = href?.replace("#", "");
  const target = id ? document.getElementById(id) : null;

  if (target) {
    event?.preventDefault?.();
    const navbarHeight = document.querySelector(".navbar-custom")?.offsetHeight || 0;
    const top = target.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
    window.scrollTo({ top, behavior: "smooth" });
    return;
  }

  if (attempts === 0) {
    event?.preventDefault?.();
  }

  if (attempts < 20) {
    window.setTimeout(() => scrollToHash(null, href, attempts + 1), 150);
  }
};

const Overview = () => (
  <section className="overview" id="overview" aria-labelledby="overview-title">
    <Container>
      <OverviewHeader
        kicker="Qué hacemos"
        title="Acompañamiento integral en seguridad"
        lead="Acompañamos a su empresa en cada frente de la seguridad y salud en el trabajo: formación certificada, asesoría normativa, equipos de protección y atención de emergencias."
      />

      <div className="overview-grid">
        {overviewItems.map((item) => (
          <OverviewCard
            key={item.id}
            href={item.href}
            label={item.label}
            onNavigate={scrollToHash}
          />
        ))}
      </div>
    </Container>
  </section>
);

export default Overview;
